(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["info-blocks"]) return;
  try {
    
$(document).ready(function() {
	$(".info-blocks-section .header").click(function(e) {
		var $parent = $(this).parent();
		$parent.find(".content").toggleClass("show");
		$parent.toggleClass("info-block-section--open");

		$parent.siblings(".info-block-section--open").removeClass("info-block-section--open");
		$parent.siblings(".info-block").find(".content").removeClass("show");
		e.preventDefault();
	});
});

  } catch(e) { console.error(e); }
})();
})();
